import { ExternalCourseModel } from 'models/externalCourse.model'
import {
  ObjectToFormDataWithFiles,
  decamelizeThatDontBreaksFile,
} from 'helpers/converters.helper'
import api from '../..'

const editExternalCourse = (
  externalCourse: ExternalCourseModel,
  id: string
) => {
  const decamelizeData = decamelizeThatDontBreaksFile(externalCourse)
  const formData = ObjectToFormDataWithFiles(decamelizeData, 'externalCourse')
  return api.patch(`administration/external_courses/${id}`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  })
}

export default editExternalCourse
